var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectsNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_544_2299",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_544_2299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 19.896L3.80762 13.5306L5.03452 12.5883L11.9999 17.9806L18.9652 12.5883L20.1921 13.5306L11.9999 19.896ZM11.9999 15.4614L3.80762 9.09604L11.9999 2.73071L20.1921 9.09604L11.9999 15.4614ZM11.9999 13.546L17.7499 9.09604L11.9999 4.64604L6.24987 9.09604L11.9999 13.546Z",
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsNav);
export default __webpack_public_path__ + "static/media/projects-nav.ebb1d6e152fa1f6643e9666f12764a97.svg";
export { ForwardRef as ReactComponent };